export const getFullAbbreviation = sty => {
  return `${sty.sectionAbbreviation} (${sty.schoolYearName})`
}

export const getFullName = sty => {
  return `${sty.sectionName} (${sty.schoolYearName})`
}
